import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ResponsiveService,
  FrkBreakpoint,
  InfoItem,
} from '@frk/eds-components';
import { GridRowData } from '@marketing/subscriptions-manage/subscription-manage.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'ft-subscriptions-products-iii-row',
  templateUrl: './subscriptions-products-iii-row.component.html',
  styleUrls: ['./subscriptions-products-iii-row.component.scss'],
})
export class SubscriptionsProductsIiiRowComponent implements OnInit, OnDestroy {
  /**
   * to check expand and collapse of additional info
   */
  public isExpanded = false;

  public isError = false;

  public additionalData: InfoItem[];
  public mobilePrimaryData: InfoItem[];

  /**
   * data to render the table
   */
  @Input() rowData: GridRowData;

  private unsubscribe$: Subject<void> = new Subject<void>();
  public isCardView$: Observable<boolean>;

  @Output()
  checkboxToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private responsiveService: ResponsiveService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.isCardView$ = this.responsiveService.isBreakpointOrBelow$(
      FrkBreakpoint.Tablet
    );
  }
  ngOnInit(): void {
    this.spinner.show('fundDocumentsLoadingSpinner');
    // dummy data for now
    this.additionalData = [
      {
        val: '1',
        label: 'DATA',
      },
      {
        val: '2',
        label: 'DATA2',
      },

      {
        val: '3',
        label: 'DATA3',
      },
      {
        val: '4',
        label: 'DATA4',
      },
    ];
    this.mobilePrimaryData = [
      {
        label: 'Subscribed Documents',
        val: '',
      },
    ];
  }

  /**
   * Handle click event when we expand or collapse the accordion
   */
  public toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  public onToggle(event: boolean): void {
    this.checkboxToggled.emit(event);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
